<template>
  <div class="tags-page" v-if="isSuperAdmin">
    <TagsNavigation />
  </div>
</template>

<script>
import TagsNavigation from "../components/tags-components/TagsNavigation.vue";
import { computed } from "vue";
import store from "../store/index";
export default {
  name: "Tags",
  components: {
    TagsNavigation,
  },
  setup() {
    const isSuperAdmin = computed({
      get: () => store.state.auth.authUser.isSuperAdmin,
    });

    return {
      isSuperAdmin,
    };
  },
};
</script>
